import {Dispatch} from 'redux'
import {IWsUserType, urlPrefixes} from '../config/constants'
import {ErrorCode} from '../config/ErrorCode'
import {getStoreInstance, IState} from '../config/store'
import {unsubscribePush} from '../helpers/push'
import { isNativeWebviewVersion2, NativeActionType, nativePostMessage } from '../helpers/reactNativeWebview'
import {isoFetchNoti, runAsync, setLocalStorageValue} from '../helpers/util'
import {logoutSuccess} from './session'
import { clearWebSocketInstance } from '../helpers/chatWs'

export const logout = () => async (dispatch: Dispatch, getState: () => IState) => {
  const {session: {userType}, i18n: {locale}} = getState()
  runAsync(ErrorCode.logout, (async () => {
    try {
      await setLocalStorageValue<boolean>('hasWarnedGuestAccount', false)
      await unsubscribePush()
    } finally {
      if (isNativeWebviewVersion2()) nativePostMessage(NativeActionType.preLogout, {userType})
      await isoFetchNoti(`/${locale}${urlPrefixes[userType]}/api/logout`)
      dispatch(logoutSuccess())
    }
  })())
}

export const deleteAccount = async () => {
  const {session: {userType}, i18n: {locale}} = getStoreInstance().getState()
  if (isNativeWebviewVersion2()) nativePostMessage(NativeActionType.preLogout, {userType})
  await isoFetchNoti(`/${locale}${urlPrefixes[userType]}/api/account`, {
    method: 'DELETE'
  })
  getStoreInstance().dispatch(logoutSuccess())
  clearWebSocketInstance(userType as IWsUserType)
}
